export default function getDetailedClassRoomInformation(state) {
    return state.classRoom;
}